import {
  Companion_instance1fvvx9vzv7oo5 as Companion_instance,
  KnownDeviceSecret16p4ozzebnrjy as KnownDeviceSecret,
} from './AuthSecrets.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance,
  UUID21wrnrlmk5y1y as UUID,
} from '../../../UUID.js.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance_0 } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../DefaultClock.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function prepareKnownDeviceSecretFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [KnownDeviceSecret__id_getInstance(), KnownDeviceSecret_subjectType_getInstance(), KnownDeviceSecret_subjectId_getInstance(), KnownDeviceSecret_hash_getInstance(), KnownDeviceSecret_deviceInfo_getInstance(), KnownDeviceSecret_establishedAt_getInstance(), KnownDeviceSecret_lastUsedAt_getInstance(), KnownDeviceSecret_expiresAt_getInstance(), KnownDeviceSecret_disabledAt_getInstance()];
  var tmp = Companion_instance.k2a();
  properties(tmp, (it) => props);
}
function KnownDeviceSecret__id$name$delegate$lambda() {
  return Companion_instance.k2a().az().v11(0);
}
function KnownDeviceSecret__id$_get_name_$ref_c2b9rl() {
  return (p0) => p0.i20();
}
function KnownDeviceSecret__id$serializer$delegate$lambda() {
  var tmp = Companion_instance.k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function KnownDeviceSecret__id$_get_serializer_$ref_mjmvmg() {
  return (p0) => p0.h2j();
}
function KnownDeviceSecret__id$annotations$delegate$lambda() {
  return Companion_instance.k2a().az().x11(0);
}
function KnownDeviceSecret__id$_get_annotations_$ref_4p9r38() {
  return (p0) => p0.bz();
}
var KnownDeviceSecret__idClass;
function KnownDeviceSecret__id() {
  if (KnownDeviceSecret__idClass === VOID) {
    class $ {
      constructor() {
        KnownDeviceSecret__id_instance = this;
        var tmp = this;
        tmp.d2p_1 = lazy(KnownDeviceSecret__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.e2p_1 = lazy(KnownDeviceSecret__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.f2p_1 = lazy(KnownDeviceSecret__id$annotations$delegate$lambda);
        this.g2p_1 = Companion_getInstance().k2p();
        this.h2p_1 = 'UUID.random()';
      }
      i20() {
        var tmp0 = this.d2p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, KnownDeviceSecret__id$_get_name_$ref_c2b9rl(), null);
        return tmp0.f2();
      }
      l2p(receiver) {
        return receiver.m2p_1;
      }
      k2j(receiver) {
        return this.l2p(receiver instanceof KnownDeviceSecret() ? receiver : THROW_CCE());
      }
      v2p(receiver, value) {
        return receiver.w2p(value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof KnownDeviceSecret() ? receiver : THROW_CCE();
        return this.v2p(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.e2p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, KnownDeviceSecret__id$_get_serializer_$ref_mjmvmg(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.f2p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, KnownDeviceSecret__id$_get_annotations_$ref_4p9r38(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'KnownDeviceSecret__id', VOID, VOID, [SerializableProperty()]);
    KnownDeviceSecret__idClass = $;
  }
  return KnownDeviceSecret__idClass;
}
var KnownDeviceSecret__id_instance;
function KnownDeviceSecret__id_getInstance() {
  if (KnownDeviceSecret__id_instance === VOID)
    new (KnownDeviceSecret__id())();
  return KnownDeviceSecret__id_instance;
}
function KnownDeviceSecret_subjectType$name$delegate$lambda() {
  return Companion_instance.k2a().az().v11(1);
}
function KnownDeviceSecret_subjectType$_get_name_$ref_5b91tp() {
  return (p0) => p0.i20();
}
function KnownDeviceSecret_subjectType$serializer$delegate$lambda() {
  var tmp = Companion_instance.k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function KnownDeviceSecret_subjectType$_get_serializer_$ref_jpopi4() {
  return (p0) => p0.h2j();
}
function KnownDeviceSecret_subjectType$annotations$delegate$lambda() {
  return Companion_instance.k2a().az().x11(1);
}
function KnownDeviceSecret_subjectType$_get_annotations_$ref_qroga0() {
  return (p0) => p0.bz();
}
var KnownDeviceSecret_subjectTypeClass;
function KnownDeviceSecret_subjectType() {
  if (KnownDeviceSecret_subjectTypeClass === VOID) {
    class $ {
      constructor() {
        KnownDeviceSecret_subjectType_instance = this;
        var tmp = this;
        tmp.x2p_1 = lazy(KnownDeviceSecret_subjectType$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.y2p_1 = lazy(KnownDeviceSecret_subjectType$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.z2p_1 = lazy(KnownDeviceSecret_subjectType$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.x2p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, KnownDeviceSecret_subjectType$_get_name_$ref_5b91tp(), null);
        return tmp0.f2();
      }
      l2p(receiver) {
        return receiver.n2p_1;
      }
      k2j(receiver) {
        return this.l2p(receiver instanceof KnownDeviceSecret() ? receiver : THROW_CCE());
      }
      a2q(receiver, value) {
        return receiver.w2p(VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof KnownDeviceSecret() ? receiver : THROW_CCE();
        return this.a2q(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.y2p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, KnownDeviceSecret_subjectType$_get_serializer_$ref_jpopi4(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.z2p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, KnownDeviceSecret_subjectType$_get_annotations_$ref_qroga0(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'KnownDeviceSecret_subjectType', VOID, VOID, [SerializableProperty()]);
    KnownDeviceSecret_subjectTypeClass = $;
  }
  return KnownDeviceSecret_subjectTypeClass;
}
var KnownDeviceSecret_subjectType_instance;
function KnownDeviceSecret_subjectType_getInstance() {
  if (KnownDeviceSecret_subjectType_instance === VOID)
    new (KnownDeviceSecret_subjectType())();
  return KnownDeviceSecret_subjectType_instance;
}
function KnownDeviceSecret_subjectId$name$delegate$lambda() {
  return Companion_instance.k2a().az().v11(2);
}
function KnownDeviceSecret_subjectId$_get_name_$ref_wymari() {
  return (p0) => p0.i20();
}
function KnownDeviceSecret_subjectId$serializer$delegate$lambda() {
  var tmp = Companion_instance.k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function KnownDeviceSecret_subjectId$_get_serializer_$ref_ejoh1() {
  return (p0) => p0.h2j();
}
function KnownDeviceSecret_subjectId$annotations$delegate$lambda() {
  return Companion_instance.k2a().az().x11(2);
}
function KnownDeviceSecret_subjectId$_get_annotations_$ref_smn56f() {
  return (p0) => p0.bz();
}
var KnownDeviceSecret_subjectIdClass;
function KnownDeviceSecret_subjectId() {
  if (KnownDeviceSecret_subjectIdClass === VOID) {
    class $ {
      constructor() {
        KnownDeviceSecret_subjectId_instance = this;
        var tmp = this;
        tmp.b2q_1 = lazy(KnownDeviceSecret_subjectId$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.c2q_1 = lazy(KnownDeviceSecret_subjectId$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.d2q_1 = lazy(KnownDeviceSecret_subjectId$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.b2q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, KnownDeviceSecret_subjectId$_get_name_$ref_wymari(), null);
        return tmp0.f2();
      }
      l2p(receiver) {
        return receiver.o2p_1;
      }
      k2j(receiver) {
        return this.l2p(receiver instanceof KnownDeviceSecret() ? receiver : THROW_CCE());
      }
      a2q(receiver, value) {
        return receiver.w2p(VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof KnownDeviceSecret() ? receiver : THROW_CCE();
        return this.a2q(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.c2q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, KnownDeviceSecret_subjectId$_get_serializer_$ref_ejoh1(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.d2q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, KnownDeviceSecret_subjectId$_get_annotations_$ref_smn56f(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'KnownDeviceSecret_subjectId', VOID, VOID, [SerializableProperty()]);
    KnownDeviceSecret_subjectIdClass = $;
  }
  return KnownDeviceSecret_subjectIdClass;
}
var KnownDeviceSecret_subjectId_instance;
function KnownDeviceSecret_subjectId_getInstance() {
  if (KnownDeviceSecret_subjectId_instance === VOID)
    new (KnownDeviceSecret_subjectId())();
  return KnownDeviceSecret_subjectId_instance;
}
function KnownDeviceSecret_hash$name$delegate$lambda() {
  return Companion_instance.k2a().az().v11(3);
}
function KnownDeviceSecret_hash$_get_name_$ref_pqnkwf() {
  return (p0) => p0.i20();
}
function KnownDeviceSecret_hash$serializer$delegate$lambda() {
  var tmp = Companion_instance.k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function KnownDeviceSecret_hash$_get_serializer_$ref_tqcrmg() {
  return (p0) => p0.h2j();
}
function KnownDeviceSecret_hash$annotations$delegate$lambda() {
  return Companion_instance.k2a().az().x11(3);
}
function KnownDeviceSecret_hash$_get_annotations_$ref_ee855w() {
  return (p0) => p0.bz();
}
var KnownDeviceSecret_hashClass;
function KnownDeviceSecret_hash() {
  if (KnownDeviceSecret_hashClass === VOID) {
    class $ {
      constructor() {
        KnownDeviceSecret_hash_instance = this;
        var tmp = this;
        tmp.e2q_1 = lazy(KnownDeviceSecret_hash$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.f2q_1 = lazy(KnownDeviceSecret_hash$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.g2q_1 = lazy(KnownDeviceSecret_hash$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.e2q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, KnownDeviceSecret_hash$_get_name_$ref_pqnkwf(), null);
        return tmp0.f2();
      }
      l2p(receiver) {
        return receiver.p2p_1;
      }
      k2j(receiver) {
        return this.l2p(receiver instanceof KnownDeviceSecret() ? receiver : THROW_CCE());
      }
      a2q(receiver, value) {
        return receiver.w2p(VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof KnownDeviceSecret() ? receiver : THROW_CCE();
        return this.a2q(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.f2q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, KnownDeviceSecret_hash$_get_serializer_$ref_tqcrmg(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.g2q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, KnownDeviceSecret_hash$_get_annotations_$ref_ee855w(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'KnownDeviceSecret_hash', VOID, VOID, [SerializableProperty()]);
    KnownDeviceSecret_hashClass = $;
  }
  return KnownDeviceSecret_hashClass;
}
var KnownDeviceSecret_hash_instance;
function KnownDeviceSecret_hash_getInstance() {
  if (KnownDeviceSecret_hash_instance === VOID)
    new (KnownDeviceSecret_hash())();
  return KnownDeviceSecret_hash_instance;
}
function KnownDeviceSecret_deviceInfo$name$delegate$lambda() {
  return Companion_instance.k2a().az().v11(4);
}
function KnownDeviceSecret_deviceInfo$_get_name_$ref_tzzqvb() {
  return (p0) => p0.i20();
}
function KnownDeviceSecret_deviceInfo$serializer$delegate$lambda() {
  var tmp = Companion_instance.k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function KnownDeviceSecret_deviceInfo$_get_serializer_$ref_de4x1u() {
  return (p0) => p0.h2j();
}
function KnownDeviceSecret_deviceInfo$annotations$delegate$lambda() {
  return Companion_instance.k2a().az().x11(4);
}
function KnownDeviceSecret_deviceInfo$_get_annotations_$ref_r44xse() {
  return (p0) => p0.bz();
}
var KnownDeviceSecret_deviceInfoClass;
function KnownDeviceSecret_deviceInfo() {
  if (KnownDeviceSecret_deviceInfoClass === VOID) {
    class $ {
      constructor() {
        KnownDeviceSecret_deviceInfo_instance = this;
        var tmp = this;
        tmp.h2q_1 = lazy(KnownDeviceSecret_deviceInfo$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.i2q_1 = lazy(KnownDeviceSecret_deviceInfo$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.j2q_1 = lazy(KnownDeviceSecret_deviceInfo$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.h2q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, KnownDeviceSecret_deviceInfo$_get_name_$ref_tzzqvb(), null);
        return tmp0.f2();
      }
      l2p(receiver) {
        return receiver.q2p_1;
      }
      k2j(receiver) {
        return this.l2p(receiver instanceof KnownDeviceSecret() ? receiver : THROW_CCE());
      }
      a2q(receiver, value) {
        return receiver.w2p(VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof KnownDeviceSecret() ? receiver : THROW_CCE();
        return this.a2q(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.i2q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, KnownDeviceSecret_deviceInfo$_get_serializer_$ref_de4x1u(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.j2q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, KnownDeviceSecret_deviceInfo$_get_annotations_$ref_r44xse(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'KnownDeviceSecret_deviceInfo', VOID, VOID, [SerializableProperty()]);
    KnownDeviceSecret_deviceInfoClass = $;
  }
  return KnownDeviceSecret_deviceInfoClass;
}
var KnownDeviceSecret_deviceInfo_instance;
function KnownDeviceSecret_deviceInfo_getInstance() {
  if (KnownDeviceSecret_deviceInfo_instance === VOID)
    new (KnownDeviceSecret_deviceInfo())();
  return KnownDeviceSecret_deviceInfo_instance;
}
function KnownDeviceSecret_establishedAt$name$delegate$lambda() {
  return Companion_instance.k2a().az().v11(5);
}
function KnownDeviceSecret_establishedAt$_get_name_$ref_jndwci() {
  return (p0) => p0.i20();
}
function KnownDeviceSecret_establishedAt$serializer$delegate$lambda() {
  var tmp = Companion_instance.k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[5];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function KnownDeviceSecret_establishedAt$_get_serializer_$ref_943srb() {
  return (p0) => p0.h2j();
}
function KnownDeviceSecret_establishedAt$annotations$delegate$lambda() {
  return Companion_instance.k2a().az().x11(5);
}
function KnownDeviceSecret_establishedAt$_get_annotations_$ref_hoviwj() {
  return (p0) => p0.bz();
}
var KnownDeviceSecret_establishedAtClass;
function KnownDeviceSecret_establishedAt() {
  if (KnownDeviceSecret_establishedAtClass === VOID) {
    class $ {
      constructor() {
        KnownDeviceSecret_establishedAt_instance = this;
        var tmp = this;
        tmp.k2q_1 = lazy(KnownDeviceSecret_establishedAt$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.l2q_1 = lazy(KnownDeviceSecret_establishedAt$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.m2q_1 = lazy(KnownDeviceSecret_establishedAt$annotations$delegate$lambda);
        var tmp_2 = this;
        // Inline function 'com.lightningkite.now' call
        tmp_2.n2q_1 = get_default(Companion_instance_0).b1m();
        this.o2q_1 = 'now()';
      }
      i20() {
        var tmp0 = this.k2q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, KnownDeviceSecret_establishedAt$_get_name_$ref_jndwci(), null);
        return tmp0.f2();
      }
      l2p(receiver) {
        return receiver.r2p_1;
      }
      k2j(receiver) {
        return this.l2p(receiver instanceof KnownDeviceSecret() ? receiver : THROW_CCE());
      }
      p2q(receiver, value) {
        return receiver.w2p(VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof KnownDeviceSecret() ? receiver : THROW_CCE();
        return this.p2q(tmp, value instanceof Instant() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.l2q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, KnownDeviceSecret_establishedAt$_get_serializer_$ref_943srb(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.m2q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, KnownDeviceSecret_establishedAt$_get_annotations_$ref_hoviwj(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'KnownDeviceSecret_establishedAt', VOID, VOID, [SerializableProperty()]);
    KnownDeviceSecret_establishedAtClass = $;
  }
  return KnownDeviceSecret_establishedAtClass;
}
var KnownDeviceSecret_establishedAt_instance;
function KnownDeviceSecret_establishedAt_getInstance() {
  if (KnownDeviceSecret_establishedAt_instance === VOID)
    new (KnownDeviceSecret_establishedAt())();
  return KnownDeviceSecret_establishedAt_instance;
}
function KnownDeviceSecret_lastUsedAt$name$delegate$lambda() {
  return Companion_instance.k2a().az().v11(6);
}
function KnownDeviceSecret_lastUsedAt$_get_name_$ref_fvuf4n() {
  return (p0) => p0.i20();
}
function KnownDeviceSecret_lastUsedAt$serializer$delegate$lambda() {
  var tmp = Companion_instance.k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[6];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function KnownDeviceSecret_lastUsedAt$_get_serializer_$ref_crjve8() {
  return (p0) => p0.h2j();
}
function KnownDeviceSecret_lastUsedAt$annotations$delegate$lambda() {
  return Companion_instance.k2a().az().x11(6);
}
function KnownDeviceSecret_lastUsedAt$_get_annotations_$ref_oguous() {
  return (p0) => p0.bz();
}
var KnownDeviceSecret_lastUsedAtClass;
function KnownDeviceSecret_lastUsedAt() {
  if (KnownDeviceSecret_lastUsedAtClass === VOID) {
    class $ {
      constructor() {
        KnownDeviceSecret_lastUsedAt_instance = this;
        var tmp = this;
        tmp.q2q_1 = lazy(KnownDeviceSecret_lastUsedAt$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.r2q_1 = lazy(KnownDeviceSecret_lastUsedAt$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.s2q_1 = lazy(KnownDeviceSecret_lastUsedAt$annotations$delegate$lambda);
        this.t2q_1 = null;
        this.u2q_1 = 'null';
      }
      i20() {
        var tmp0 = this.q2q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, KnownDeviceSecret_lastUsedAt$_get_name_$ref_fvuf4n(), null);
        return tmp0.f2();
      }
      l2p(receiver) {
        return receiver.s2p_1;
      }
      k2j(receiver) {
        return this.l2p(receiver instanceof KnownDeviceSecret() ? receiver : THROW_CCE());
      }
      v2q(receiver, value) {
        return receiver.w2p(VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof KnownDeviceSecret() ? receiver : THROW_CCE();
        return this.v2q(tmp, (value == null ? true : value instanceof Instant()) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.r2q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, KnownDeviceSecret_lastUsedAt$_get_serializer_$ref_crjve8(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.s2q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, KnownDeviceSecret_lastUsedAt$_get_annotations_$ref_oguous(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'KnownDeviceSecret_lastUsedAt', VOID, VOID, [SerializableProperty()]);
    KnownDeviceSecret_lastUsedAtClass = $;
  }
  return KnownDeviceSecret_lastUsedAtClass;
}
var KnownDeviceSecret_lastUsedAt_instance;
function KnownDeviceSecret_lastUsedAt_getInstance() {
  if (KnownDeviceSecret_lastUsedAt_instance === VOID)
    new (KnownDeviceSecret_lastUsedAt())();
  return KnownDeviceSecret_lastUsedAt_instance;
}
function KnownDeviceSecret_expiresAt$name$delegate$lambda() {
  return Companion_instance.k2a().az().v11(7);
}
function KnownDeviceSecret_expiresAt$_get_name_$ref_7tpwpu() {
  return (p0) => p0.i20();
}
function KnownDeviceSecret_expiresAt$serializer$delegate$lambda() {
  var tmp = Companion_instance.k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[7];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function KnownDeviceSecret_expiresAt$_get_serializer_$ref_r388g5() {
  return (p0) => p0.h2j();
}
function KnownDeviceSecret_expiresAt$annotations$delegate$lambda() {
  return Companion_instance.k2a().az().x11(7);
}
function KnownDeviceSecret_expiresAt$_get_annotations_$ref_3ifopj() {
  return (p0) => p0.bz();
}
var KnownDeviceSecret_expiresAtClass;
function KnownDeviceSecret_expiresAt() {
  if (KnownDeviceSecret_expiresAtClass === VOID) {
    class $ {
      constructor() {
        KnownDeviceSecret_expiresAt_instance = this;
        var tmp = this;
        tmp.w2q_1 = lazy(KnownDeviceSecret_expiresAt$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.x2q_1 = lazy(KnownDeviceSecret_expiresAt$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.y2q_1 = lazy(KnownDeviceSecret_expiresAt$annotations$delegate$lambda);
        this.z2q_1 = null;
        this.a2r_1 = 'null';
      }
      i20() {
        var tmp0 = this.w2q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, KnownDeviceSecret_expiresAt$_get_name_$ref_7tpwpu(), null);
        return tmp0.f2();
      }
      l2p(receiver) {
        return receiver.t2p_1;
      }
      k2j(receiver) {
        return this.l2p(receiver instanceof KnownDeviceSecret() ? receiver : THROW_CCE());
      }
      v2q(receiver, value) {
        return receiver.w2p(VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof KnownDeviceSecret() ? receiver : THROW_CCE();
        return this.v2q(tmp, (value == null ? true : value instanceof Instant()) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.x2q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, KnownDeviceSecret_expiresAt$_get_serializer_$ref_r388g5(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.y2q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, KnownDeviceSecret_expiresAt$_get_annotations_$ref_3ifopj(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'KnownDeviceSecret_expiresAt', VOID, VOID, [SerializableProperty()]);
    KnownDeviceSecret_expiresAtClass = $;
  }
  return KnownDeviceSecret_expiresAtClass;
}
var KnownDeviceSecret_expiresAt_instance;
function KnownDeviceSecret_expiresAt_getInstance() {
  if (KnownDeviceSecret_expiresAt_instance === VOID)
    new (KnownDeviceSecret_expiresAt())();
  return KnownDeviceSecret_expiresAt_instance;
}
function KnownDeviceSecret_disabledAt$name$delegate$lambda() {
  return Companion_instance.k2a().az().v11(8);
}
function KnownDeviceSecret_disabledAt$_get_name_$ref_kl7sxa() {
  return (p0) => p0.i20();
}
function KnownDeviceSecret_disabledAt$serializer$delegate$lambda() {
  var tmp = Companion_instance.k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[8];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function KnownDeviceSecret_disabledAt$_get_serializer_$ref_x2rlo9() {
  return (p0) => p0.h2j();
}
function KnownDeviceSecret_disabledAt$annotations$delegate$lambda() {
  return Companion_instance.k2a().az().x11(8);
}
function KnownDeviceSecret_disabledAt$_get_annotations_$ref_nz838d() {
  return (p0) => p0.bz();
}
var KnownDeviceSecret_disabledAtClass;
function KnownDeviceSecret_disabledAt() {
  if (KnownDeviceSecret_disabledAtClass === VOID) {
    class $ {
      constructor() {
        KnownDeviceSecret_disabledAt_instance = this;
        var tmp = this;
        tmp.b2r_1 = lazy(KnownDeviceSecret_disabledAt$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.c2r_1 = lazy(KnownDeviceSecret_disabledAt$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.d2r_1 = lazy(KnownDeviceSecret_disabledAt$annotations$delegate$lambda);
        this.e2r_1 = null;
        this.f2r_1 = 'null';
      }
      i20() {
        var tmp0 = this.b2r_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, KnownDeviceSecret_disabledAt$_get_name_$ref_kl7sxa(), null);
        return tmp0.f2();
      }
      l2p(receiver) {
        return receiver.u2p_1;
      }
      k2j(receiver) {
        return this.l2p(receiver instanceof KnownDeviceSecret() ? receiver : THROW_CCE());
      }
      v2q(receiver, value) {
        return receiver.w2p(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof KnownDeviceSecret() ? receiver : THROW_CCE();
        return this.v2q(tmp, (value == null ? true : value instanceof Instant()) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.c2r_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, KnownDeviceSecret_disabledAt$_get_serializer_$ref_x2rlo9(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.d2r_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, KnownDeviceSecret_disabledAt$_get_annotations_$ref_nz838d(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'KnownDeviceSecret_disabledAt', VOID, VOID, [SerializableProperty()]);
    KnownDeviceSecret_disabledAtClass = $;
  }
  return KnownDeviceSecret_disabledAtClass;
}
var KnownDeviceSecret_disabledAt_instance;
function KnownDeviceSecret_disabledAt_getInstance() {
  if (KnownDeviceSecret_disabledAt_instance === VOID)
    new (KnownDeviceSecret_disabledAt())();
  return KnownDeviceSecret_disabledAt_instance;
}
//region block: exports
export {
  prepareKnownDeviceSecretFields as prepareKnownDeviceSecretFields17wic287aey8t,
};
//endregion

//# sourceMappingURL=KnownDeviceSecretFields.mjs.map
